export const getLoaderNamespace = (namespace: string) => `${namespace}-loader`;
